import { createSelector } from 'reselect';
import { careerAndSeasonStatsSelector } from './simple-selectors';

export const careerAndSeasonStatsDataSelector = createSelector(
    careerAndSeasonStatsSelector,
    careerAndSeasonStats => careerAndSeasonStats.data
);